<div class="employees-page">

  <!-- PAGE HEADER -->

  <div class="page-header">

    <div>

      <div class="breadcrumb">
        HR Management / Employees
      </div>

      <h1>
        Employees
      </h1>

      <p>
        Manage your organization's employees and workforce.
      </p>

    </div>

    <div class="header-actions" style="display:flex;gap:8px;flex-wrap:wrap;align-items:center;">
      <input #empCsvInput type="file" hidden accept=".csv,text/csv" (change)="onEmployeeCsvPicked($event)" />
      <button mat-stroked-button type="button" (click)="downloadEmployeeTemplate()">
        <mat-icon>description</mat-icon>
        CSV Template
      </button>
      <button mat-stroked-button type="button" (click)="exportEmployeesCsv()">
        <mat-icon>download</mat-icon>
        Export CSV
      </button>
      <button mat-stroked-button type="button" (click)="empCsvInput.click()">
        <mat-icon>upload_file</mat-icon>
        Import CSV
      </button>
      <button
        mat-raised-button
        color="primary"
        (click)="addEmployee()">
        <mat-icon>person_add</mat-icon>
        Add Employee
      </button>
    </div>

  </div>


  <!-- STATISTICS -->

  <div class="stats-grid">

    <mat-card class="stat-card">

      <div class="stat-icon primary">
        <mat-icon>
          groups
        </mat-icon>
      </div>

      <div class="stat-info">

        <span>
          Total Employees
        </span>

        <strong>
          {{ totalEmployees }}
        </strong>

      </div>

    </mat-card>


    <mat-card class="stat-card">

      <div class="stat-icon success">
        <mat-icon>
          person
        </mat-icon>
      </div>

      <div class="stat-info">

        <span>
          Active Employees
        </span>

        <strong>
          {{ activeEmployees }}
        </strong>

      </div>

    </mat-card>


    <mat-card class="stat-card">

      <div class="stat-icon warning">
        <mat-icon>
          person_off
        </mat-icon>
      </div>

      <div class="stat-info">

        <span>
          Inactive Employees
        </span>

        <strong>
          {{ inactiveEmployees }}
        </strong>

      </div>

    </mat-card>


    <mat-card class="stat-card">

      <div class="stat-icon purple">
        <mat-icon>
          person_add
        </mat-icon>
      </div>

      <div class="stat-info">

        <span>
          New Employees
        </span>

        <strong>
          {{ newEmployees }}
        </strong>

      </div>

    </mat-card>

  </div>


  <!-- EMPLOYEE LIST -->

  <mat-card class="employee-card">

    <!-- CARD HEADER -->

    <div class="card-header">

      <div>

        <h2>
          Employee Directory
        </h2>

        <p>
          View and manage all employees
        </p>

      </div>

      <button
        mat-stroked-button
        (click)="loadEmployees()">

        <mat-icon>
          refresh
        </mat-icon>

        Refresh

      </button>

    </div>


    <mat-divider></mat-divider>


    <!-- FILTERS -->

    <div class="filters">

      <!-- SEARCH -->

      <mat-form-field
        appearance="outline"
        class="search-field">

        <mat-label>
          Search employees
        </mat-label>

        <input
          matInput
          [(ngModel)]="searchText"
          (ngModelChange)="filterEmployees()"
          placeholder="Name, ID or email">

        <mat-icon matSuffix>
          search
        </mat-icon>

      </mat-form-field>


      <!-- DEPARTMENT -->

      <mat-form-field
        appearance="outline">

        <mat-label>
          Department
        </mat-label>

        <mat-select
          [(ngModel)]="selectedDepartment"
          (selectionChange)="filterEmployees()">

          <mat-option
            *ngFor="let department of departments"
            [value]="department">

            {{ department }}

          </mat-option>

        </mat-select>

      </mat-form-field>


      <!-- STATUS -->

      <mat-form-field
        appearance="outline">

        <mat-label>
          Status
        </mat-label>

        <mat-select
          [(ngModel)]="selectedStatus"
          (selectionChange)="filterEmployees()">

          <mat-option
            *ngFor="let status of statuses"
            [value]="status">

            {{ status }}

          </mat-option>

        </mat-select>

      </mat-form-field>


      <!-- CLEAR -->

      <button
        mat-button
        (click)="clearFilters()">

        Clear Filters

      </button>

    </div>


    <!-- LOADING -->

    <div
      class="loading-container"
      *ngIf="loading">

      <mat-spinner
        diameter="45">
      </mat-spinner>

      <p>
        Loading employees...
      </p>

    </div>


    <!-- TABLE -->

    <div
      class="table-container"
      *ngIf="!loading">

      <table
        mat-table
        [dataSource]="filteredEmployees"
        class="employee-table">


        <!-- EMPLOYEE -->

        <ng-container
          matColumnDef="employee">

          <th
            mat-header-cell
            *matHeaderCellDef>

            Employee

          </th>

          <td
            mat-cell
            *matCellDef="let employee">

            <div class="employee-info">

              <div class="employee-avatar">

                {{ employee.avatar }}

              </div>

              <div>

                <strong>
                  {{ employee.firstName }} {{ employee.lastName }}
                </strong>

                <span>
                  {{ employee.email }}
                </span>

              </div>

            </div>

          </td>

        </ng-container>


        <!-- EMPLOYEE ID -->

        <ng-container
          matColumnDef="employeeId">

          <th
            mat-header-cell
            *matHeaderCellDef>

            Employee ID

          </th>

          <td
            mat-cell
            *matCellDef="let employee">

            {{ employee.employeeNumber || employee.id }}

          </td>

        </ng-container>


        <!-- DEPARTMENT -->

        <ng-container
          matColumnDef="department">

          <th
            mat-header-cell
            *matHeaderCellDef>

            Department

          </th>

          <td
            mat-cell
            *matCellDef="let employee">

            {{ employee.department }}

          </td>

        </ng-container>


         <!-- DESIGNATION -->

        <ng-container
          matColumnDef="position">

          <th
            mat-header-cell
            *matHeaderCellDef>

            Position

          </th>

          <td
            mat-cell
            *matCellDef="let employee">

            {{ employee.position }}

          </td>

        </ng-container>


        <!-- CONTACT -->

        <ng-container
          matColumnDef="contact">

          <th
            mat-header-cell
            *matHeaderCellDef>

            Contact

          </th>

          <td
            mat-cell
            *matCellDef="let employee">

            <div class="contact-info">

              <span>
                {{ employee.phone }}
              </span>

              <small>
                {{ employee.email }}
              </small>

            </div>

          </td>

        </ng-container>


        <!-- STATUS -->

        <ng-container
          matColumnDef="status">

          <th
            mat-header-cell
            *matHeaderCellDef>

            Status

          </th>

          <td
            mat-cell
            *matCellDef="let employee">

            <span
              class="status-badge"
              [class.active]="employee.status === 'Active'"
              [class.inactive]="employee.status === 'Inactive'">

              <span class="status-dot">
              </span>

              {{ employee.status }}

            </span>

          </td>

        </ng-container>


        <!-- ACTIONS -->

        <ng-container
          matColumnDef="actions">

          <th
            mat-header-cell
            *matHeaderCellDef>

            Actions

          </th>

          <td
            mat-cell
            *matCellDef="let employee">

            <button
              mat-icon-button
              matTooltip="View Employee"
              (click)="viewEmployee(employee)">

              <mat-icon>
                visibility
              </mat-icon>

            </button>

            <button
              mat-icon-button
              matTooltip="Document Center"
              (click)="openDocuments(employee)">

              <mat-icon>
                folder_shared
              </mat-icon>

            </button>


            <button
              mat-icon-button
              matTooltip="Edit Employee"
              (click)="editEmployee(employee)">

              <mat-icon>
                edit
              </mat-icon>

            </button>


            <button
              mat-icon-button
              color="warn"
              matTooltip="Delete Employee"
              (click)="deleteEmployee(employee)">

              <mat-icon>
                delete
              </mat-icon>

            </button>

          </td>

        </ng-container>


        <!-- HEADER -->

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns">
        </tr>


        <!-- ROW -->

        <tr
          mat-row
          *matRowDef="
            let row;
            columns: displayedColumns;
          ">
        </tr>


      </table>


      <!-- NO DATA -->

      <div
        class="no-data"
        *ngIf="filteredEmployees.length === 0">

        <mat-icon>
          people_outline
        </mat-icon>

        <h3>
          No Employees Found
        </h3>

        <p>
          Try changing your search or filter.
        </p>

      </div>

    </div>

  </mat-card>

</div>